import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { articles, categories, testimonials, stats } from '@/mocks/data';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const hotArticles = articles.filter((a) => a.isHot);
  const latestArticles = articles.slice(0, 6);

  return (
    <>
      <Navbar />

      <main>
        {/* Hero Section */}
        <section className="relative w-full h-[500px] md:h-[620px] flex items-center justify-center overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Abstract%20warm%20toned%20geometric%20composition%20with%20soft%20gradients%20of%20coral%20orange%20and%20cream%2C%20overlapping%20translucent%20circles%20and%20organic%20shapes%2C%20modern%20artistic%20minimal%20style%2C%20smooth%20textures%2C%20elegant%20atmospheric%20background%2C%20luxurious%20editorial%20design%2C%20warm%20ambient%20glow&width=1800&height=900&seq=chigua-hero-bg&orientation=landscape"
              alt="吃瓜群官网背景"
              className="w-full h-full object-cover object-top"
              loading="eager"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
          </div>
          <div className="relative z-10 w-full text-center px-4 md:px-6">
            <div className="max-w-3xl mx-auto">
              <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/20 backdrop-blur-sm border border-background-50/30 mb-6">
                <span className="w-1.5 h-1.5 rounded-full bg-accent-500 animate-pulse"></span>
                <span className="text-background-50 text-xs font-medium">实时更新 · 全网最快吃瓜平台</span>
              </div>
              <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-background-50 leading-tight mb-5">
                吃瓜群众
                <br />
                免费吃瓜第一站
              </h1>
              <p className="text-background-50/80 text-base md:text-lg max-w-xl mx-auto mb-8 leading-relaxed">
                网红塌房现场直击 · 明星大瓜实时追踪 · 黑料曝光独家揭秘 · 吃瓜路线一键导航
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
                <Link
                  to="/category/zuixin-baoliao"
                  className="px-7 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap"
                >
                  立即吃瓜
                  <i className="ri-arrow-right-line ml-2 text-xs"></i>
                </Link>
                <Link
                  to="/category/chigua-luxian"
                  className="px-7 py-3 rounded-full bg-background-50/15 backdrop-blur-sm text-background-50 font-medium text-sm hover:bg-background-50/25 transition-all cursor-pointer border border-background-50/25 whitespace-nowrap"
                >
                  吃瓜路线
                  <i className="ri-road-map-line ml-2 text-xs"></i>
                </Link>
              </div>
            </div>
          </div>
          <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
            <div className="w-6 h-10 rounded-full border-2 border-background-50/40 flex items-start justify-center pt-2">
              <div className="w-1 h-2.5 rounded-full bg-background-50/60 animate-bounce"></div>
            </div>
          </div>
        </section>

        {/* Hot Topics Ticker */}
        <section className="bg-background-50 border-b border-background-200/70">
          <div className="px-4 md:px-6 py-3">
            <div className="max-w-7xl mx-auto flex items-center gap-4">
              <span className="shrink-0 flex items-center gap-1.5 text-xs font-semibold text-primary-600 whitespace-nowrap">
                <i className="ri-fire-line"></i>
                热门话题
              </span>
              <div className="flex-1 overflow-hidden">
                <div className="flex items-center gap-6 animate-marquee whitespace-nowrap">
                  {['#顶流男星片场耍大牌', '#网红带货三无产品', '#娱乐圈阴阳合同', '#女团队内不和', '#吃播假吃催吐', '#吃瓜群APP上线'].map((tag) => (
                    <Link
                      key={tag}
                      to="/"
                      className="text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                    >
                      {tag}
                    </Link>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Category Grid */}
        <section className="py-14 md:py-20 bg-background-50">
          <div className="px-4 md:px-6">
            <div className="max-w-7xl mx-auto">
              <div className="text-center mb-12">
                <span className="inline-block text-xs font-semibold text-primary-600 uppercase tracking-wider mb-2">
                  吃瓜导航
                </span>
                <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-3">
                  选你想吃的瓜
                </h2>
                <p className="text-foreground-500 text-sm max-w-lg mx-auto">
                  五大吃瓜频道，精准投喂你想要的每一口瓜
                </p>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
                {categories.map((cat, idx) => (
                  <Link
                    key={cat.id}
                    to={`/category/${cat.slug}`}
                    className={`group rounded-lg p-5 transition-all duration-300 cursor-pointer ${
                      idx === 3
                        ? 'bg-accent-500 text-background-50 hover:bg-accent-600'
                        : 'bg-background-100 hover:bg-background-200'
                    }`}
                  >
                    <div className={`w-10 h-10 rounded-lg flex items-center justify-center mb-3 ${
                      idx === 3
                        ? 'bg-background-50/20'
                        : 'bg-primary-100 text-primary-600'
                    }`}>
                      <i className={`${cat.icon} text-lg ${idx === 3 ? 'text-background-50' : ''}`}></i>
                    </div>
                    <h3 className={`font-heading text-base font-semibold mb-1 ${idx === 3 ? 'text-background-50' : 'text-foreground-950'}`}>
                      {cat.name}
                    </h3>
                    <p className={`text-xs leading-relaxed mb-3 ${idx === 3 ? 'text-background-50/80' : 'text-foreground-500'}`}>
                      {cat.description}
                    </p>
                    <span className={`text-xs font-medium ${idx === 3 ? 'text-background-50/70' : 'text-primary-600'}`}>
                      {cat.count.toLocaleString()} 条内容
                      <i className="ri-arrow-right-line ml-1 text-[10px] group-hover:ml-1.5 transition-all"></i>
                    </span>
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Headline Article */}
        <section className="py-14 md:py-20 bg-background-100">
          <div className="px-4 md:px-6">
            <div className="max-w-7xl mx-auto">
              <div className="flex items-center gap-2 mb-8">
                <span className="w-1 h-5 rounded-full bg-primary-500"></span>
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
                  头条大瓜
                </h2>
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-5 gap-6">
                {articles.filter(a => a.isTop).slice(0, 2).map((article, idx) => (
                  <Link
                    key={article.id}
                    to={`/article/${article.slug}`}
                    className={`group relative rounded-lg overflow-hidden cursor-pointer ${
                      idx === 0 ? 'lg:col-span-3' : 'lg:col-span-2'
                    }`}
                  >
                    <div className={`relative ${idx === 0 ? 'h-[320px] md:h-[420px]' : 'h-[320px] md:h-[420px]'}`}>
                      <img
                        src={article.coverImage}
                        alt={article.title}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                        loading="lazy"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent"></div>
                      <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                        <span className="inline-block px-2.5 py-0.5 rounded-full bg-primary-500 text-background-50 text-xs font-medium mb-3">
                          {article.category}
                        </span>
                        <h3 className="font-heading text-lg md:text-xl font-bold text-background-50 mb-2 group-hover:text-primary-200 transition-colors line-clamp-2">
                          {article.title}
                        </h3>
                        <p className="text-background-50/70 text-sm line-clamp-1 mb-3">
                          {article.excerpt}
                        </p>
                        <div className="flex items-center gap-4 text-xs text-background-50/60">
                          <span className="flex items-center gap-1">
                            <i className="ri-eye-line"></i>
                            {article.views >= 10000 ? `${(article.views / 10000).toFixed(1)}万` : article.views}
                          </span>
                          <span className="flex items-center gap-1">
                            <i className="ri-chat-3-line"></i>
                            {article.comments}
                          </span>
                          <span>{article.publishDate}</span>
                        </div>
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Latest Articles */}
        <section className="py-14 md:py-20 bg-background-50">
          <div className="px-4 md:px-6">
            <div className="max-w-7xl mx-auto">
              <div className="flex items-center justify-between mb-8">
                <div className="flex items-center gap-2">
                  <span className="w-1 h-5 rounded-full bg-accent-500"></span>
                  <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
                    最新爆料
                  </h2>
                </div>
                <Link
                  to="/category/zuixin-baoliao"
                  className="text-sm text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1 whitespace-nowrap"
                >
                  查看全部
                  <i className="ri-arrow-right-line text-xs"></i>
                </Link>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                {latestArticles.map((article) => (
                  <Link
                    key={article.id}
                    to={`/article/${article.slug}`}
                    className="group rounded-lg bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer overflow-hidden"
                  >
                    <div className="h-48 overflow-hidden">
                      <img
                        src={article.coverImage}
                        alt={article.title}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                        loading="lazy"
                      />
                    </div>
                    <div className="p-4">
                      <div className="flex items-center gap-2 mb-2">
                        <span className="px-2 py-0.5 rounded-full bg-accent-100 text-accent-800 text-[11px] font-medium">
                          {article.category}
                        </span>
                        {article.isHot && (
                          <span className="px-2 py-0.5 rounded-full bg-primary-100 text-primary-700 text-[11px] font-medium flex items-center gap-0.5">
                            <i className="ri-fire-line text-[10px]"></i>
                            热
                          </span>
                        )}
                      </div>
                      <h3 className="font-heading text-base font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors mb-2 line-clamp-2">
                        {article.title}
                      </h3>
                      <p className="text-foreground-500 text-xs leading-relaxed line-clamp-2 mb-3">
                        {article.excerpt}
                      </p>
                      <div className="flex items-center justify-between text-[11px] text-foreground-400">
                        <span>{article.publishDate}</span>
                        <div className="flex items-center gap-3">
                          <span className="flex items-center gap-1">
                            <i className="ri-eye-line"></i>
                            {article.views >= 10000 ? `${(article.views / 10000).toFixed(1)}万` : article.views}
                          </span>
                          <span className="flex items-center gap-1">
                            <i className="ri-chat-3-line"></i>
                            {article.comments}
                          </span>
                        </div>
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Stats Section */}
        <section className="py-14 md:py-20 bg-foreground-950">
          <div className="px-4 md:px-6">
            <div className="max-w-7xl mx-auto">
              <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
                {[
                  { value: stats.totalArticles.toLocaleString(), label: '累计爆料', suffix: '+', icon: 'ri-article-line' },
                  { value: (stats.dailyVisitors / 10000).toFixed(0), label: '日活吃瓜群众', suffix: '万+', icon: 'ri-user-smile-line' },
                  { value: (stats.registeredUsers / 10000).toFixed(0), label: '注册瓜友', suffix: '万+', icon: 'ri-group-line' },
                  { value: (stats.totalComments / 10000).toFixed(0), label: '累计评论', suffix: '万+', icon: 'ri-chat-1-line' },
                ].map((stat) => (
                  <div key={stat.label} className="text-center">
                    <div className="w-12 h-12 mx-auto mb-3 rounded-lg bg-primary-500/20 flex items-center justify-center">
                      <i className={`${stat.icon} text-primary-400 text-xl`}></i>
                    </div>
                    <div className="font-heading text-3xl md:text-4xl font-bold text-background-50 mb-1">
                      {stat.value}
                      <span className="text-primary-400">{stat.suffix}</span>
                    </div>
                    <div className="text-foreground-400 text-sm">{stat.label}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Testimonials */}
        <section className="py-14 md:py-20 bg-background-100">
          <div className="px-4 md:px-6">
            <div className="max-w-7xl mx-auto">
              <div className="text-center mb-12">
                <span className="inline-block text-xs font-semibold text-accent-600 uppercase tracking-wider mb-2">
                  瓜友评价
                </span>
                <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-3">
                  吃瓜群众怎么说
                </h2>
                <p className="text-foreground-500 text-sm">
                  来自真实用户的走心评价
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
                {testimonials.map((t) => (
                  <div
                    key={t.id}
                    className="rounded-lg bg-background-50 border border-background-200/70 p-6"
                  >
                    <div className="flex items-center gap-1 mb-4">
                      {Array.from({ length: t.rating }).map((_, i) => (
                        <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                      ))}
                    </div>
                    <p className="text-foreground-700 text-sm leading-relaxed mb-5">
                      &ldquo;{t.content}&rdquo;
                    </p>
                    <div className="flex items-center gap-3">
                      <img
                        src={t.avatar}
                        alt={t.name}
                        className="w-10 h-10 rounded-full object-cover"
                        loading="lazy"
                      />
                      <div>
                        <div className="text-sm font-semibold text-foreground-950">{t.name}</div>
                        <div className="text-xs text-foreground-400">{t.platform} 用户</div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="relative py-20 md:py-28 bg-background-50 overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Soft%20abstract%20warm%20gradient%20background%20with%20overlapping%20translucent%20geometric%20shapes%2C%20coral%20and%20cream%20tones%2C%20modern%20minimal%20art%20style%2C%20smooth%20flowing%20textures%2C%20elegant%20atmospheric%20design%2C%20subtle%20light%20leaks%2C%20dreamy%20warm%20ambiance&width=1800&height=600&seq=chigua-cta-bg&orientation=landscape"
              alt=""
              className="w-full h-full object-cover object-top opacity-30"
              loading="lazy"
            />
          </div>
          <div className="relative z-10 px-4 md:px-6">
            <div className="max-w-2xl mx-auto text-center">
              <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 mb-4">
                加入吃瓜群众大家庭
              </h2>
              <p className="text-foreground-500 text-base mb-8 max-w-lg mx-auto">
                每天百万吃瓜群众在线等瓜，新鲜热乎的大瓜从不迟到。快来和我们一起快乐吃瓜吧！
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
                <Link
                  to="/category/zuixin-baoliao"
                  className="px-7 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap"
                >
                  开始吃瓜
                  <i className="ri-arrow-right-line ml-2 text-xs"></i>
                </Link>
                <Link
                  to="/about"
                  className="px-7 py-3 rounded-full bg-secondary-100 text-secondary-800 font-medium text-sm hover:bg-secondary-200 transition-all cursor-pointer whitespace-nowrap"
                >
                  了解更多
                </Link>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />

      {/* JSON-LD Structured Data */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '吃瓜群官网 - 吃瓜群众免费吃瓜 | 在线爆料与吃瓜路线追踪',
            description: '专注吃瓜群众免费吃瓜与在线爆料内容聚合平台。实时更新网红博主塌房现场、明星大瓜及热门黑料事件。',
            url: 'https://www.chiguaqun.com/',
            isPartOf: {
              '@type': 'WebSite',
              name: '吃瓜群',
              url: 'https://www.chiguaqun.com',
            },
            breadcrumb: {
              '@type': 'BreadcrumbList',
              itemListElement: [
                {
                  '@type': 'ListItem',
                  position: 1,
                  name: '首页',
                  item: 'https://www.chiguaqun.com/',
                },
              ],
            },
          }),
        }}
      />
    </>
  );
}